import {
  LOAD_CALENDAR,
  INIT_CALENDAR,
  LOAD_CALENDAR_STARTED,
  LOAD_CALENDAR_COMPLETED,
  LOAD_CALENDAR_FAILED,
  INIT_CALENDAR_STARTED,
  INIT_CALENDAR_COMPLETED,
  INIT_CALENDAR_FAILED,
  ADD_EVENT,
  UPDATE_EVENT,
  REMOVE_EVENT,
} from "./types"

export const loadCalendar = ({
  query: {
    startDateTime,
    endDateTime,
    zone,
    groupByDay,
    resourceQuery,
    eventQuery,
    limit,
    offset,
    orderBy,
  },
  planId,
  keepCount,
}) => ({
  type: LOAD_CALENDAR,
  payload: {
    query: {
      startDateTime,
      endDateTime,
      zone,
      groupByDay,
      resourceQuery,
      eventQuery,
      limit,
      offset,
      orderBy,
    },
    planId,
    keepCount,
  },
})

export const initCalendar = ({
  query: {
    startDateTime,
    endDateTime,
    zone,
    groupByDay,
    resourceQuery,
    eventQuery,
    limit,
    offset,
    orderBy,
  },
  planId,
}) => ({
  type: INIT_CALENDAR,
  payload: {
    query: {
      startDateTime,
      endDateTime,
      zone,
      groupByDay,
      resourceQuery,
      eventQuery,
      limit,
      offset,
      orderBy,
    },
    planId,
  },
})

export const loadCalendarStarted = () => ({
  type: LOAD_CALENDAR_STARTED,
  payload: {},
})

export const loadCalendarCompleted = (data, count, keepCount) => ({
  type: LOAD_CALENDAR_COMPLETED,
  payload: {
    data,
    count,
    keepCount,
  },
})

export const loadCalendarFailed = () => ({
  type: LOAD_CALENDAR_FAILED,
  payload: {},
})

export const initCalendarStarted = () => ({
  type: INIT_CALENDAR_STARTED,
  payload: {},
})

export const initCalendarCompleted = (data, count) => ({
  type: INIT_CALENDAR_COMPLETED,
  payload: {
    data,
    count,
  },
})

export const initCalendarFailed = () => ({
  type: INIT_CALENDAR_FAILED,
  payload: {},
})

export const addEvent = (event, resources) => ({
  type: ADD_EVENT,
  payload: {
    event,
    resources,
  },
})

export const updateEvent = event => ({
  type: UPDATE_EVENT,
  payload: {
    event,
  },
})

export const removeEvent = event => ({
  type: REMOVE_EVENT,
  payload: {
    event,
  },
})
